import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";
import flagSensorMMFormMeta, { IFlagSensorMMFormMeta } from "./FlagSensorMMFormMeta";
import gbpFormMeta, { IGBPFormMeta } from "./GBPFormMeta";
import indexReferencePointFormMeta, { I_IndexReferencePointFormMeta } from "./IndexReferencePointFormMeta";
import miscFormMeta, { IMiscFormMeta } from "./MiscFormMeta";

export interface IFitsNextFormMeta extends IFlagSensorMMFormMeta, IGBPFormMeta, I_IndexReferencePointFormMeta, IMiscFormMeta {
  
  schema: any;
}

let fitsNextFormMeta = {} as IFitsNextFormMeta;

fitsNextFormMeta = {...fitsNextFormMeta, ...flagSensorMMFormMeta, ...gbpFormMeta, ...indexReferencePointFormMeta, ...miscFormMeta 
};

fitsNextFormMeta.schema = yup.object().shape(getValidationSchema(fitsNextFormMeta));

export default fitsNextFormMeta;